import { useWindowDimensions } from 'react-native';

import { BREAKPOINTS } from '@garnish/constants';
import { useFluidSize } from '../useFluidSize';
import { usePrimedBreakpointHelpers } from '../useBreakpointHelpers';
import { usePrimedCheckOrientation } from '../useCheckOrientation';
import type { UseResponsiveResult } from './useResponsive.types';

export const useResponsive = (
  breakpoints: typeof BREAKPOINTS = BREAKPOINTS,
): UseResponsiveResult => {
  const { width, height } = useWindowDimensions();
  const breakpointHelpers = usePrimedBreakpointHelpers(width);

  return {
    windowWidth: width,
    windowHeight: height,
    minWidth: breakpointHelpers.checkMinWidth,
    currentBreakpoint: breakpointHelpers.currentBreakpoint,
    checkOrientation: usePrimedCheckOrientation(width, height),
    match: breakpointHelpers.matchByBreakpointIndex,
    fluid: useFluidSize(getLockMinMax(breakpoints)),
  };
};

const getLockMinMax = (breakpoints: typeof BREAKPOINTS) => {
  const minBreakpoint = breakpoints[0];
  const maxBreakpoint = breakpoints[3];

  return { min: minBreakpoint.MAX, max: maxBreakpoint.BODY as number };
};
